export const SET_MESAS_DIRETORAS =
  "MESAS_DIRETORAS/SET_MESAS_DIRETORAS";
export const SET_MESA_DIRETORA =
  "MESAS_DIRETORAS/SET_MESA_DIRETORA";
export const SET_PAGINATION = "MESAS_DIRETORAS/SET_PAGINATION";
